const chartType = {
  COLUMN_STACKED: 'column-stacked',
  DONUT: 'donut',
  COLUMN: 'column',
  BAR: 'bar',
  LINE: 'line'
}

export default chartType
